import React from "react";

const Report = ({ color: _color }: { color?: string }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 20 20" fill="none" className="custom-icon" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.625 2.25H3.375C3.07663 2.25 2.79048 2.36853 2.5795 2.5795C2.36853 2.79048 2.25 3.07663 2.25 3.375V14.625C2.25 14.9234 2.36853 15.2095 2.5795 15.4205C2.79048 15.6315 3.07663 15.75 3.375 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V3.375C15.75 3.07663 15.6315 2.79048 15.4205 2.5795C15.2095 2.36853 14.9234 2.25 14.625 2.25Z" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.875 11.625L9.75 13.125L12.75 9.375M5.25 5.625H12.75M5.25 8.625H8.25" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default Report;
